import React, { JSX, useEffect, useState } from 'react';
import ViewAllPanel from '../ViewAllPanel';
import {
  AddFilterType,
  FacetValue,
  RemoveFilterType,
  Specialty,
  SuperSpecialty,
} from 'components/types/FilterTypes';
import { getSearchWidget, getSpecialtiesComboSearchSrc } from 'lib/util';
import Icons from 'components/atoms/Icons';
import { classNames } from 'assets/utils/helper';
import Axios from 'axios';

type SpecialtyFilterProps = {
  addFilter: AddFilterType;
  filters: Array<FacetValue>;
  filterCategory: string;
  inputType?: string;
  placeholder: string;
  removeFilter: RemoveFilterType;
  selectedData: Array<string>;
  selectedDataSecondary?: Array<string>;
  title: string;
  superSpecialties: Array<SuperSpecialty>;
};

const SpecialtyFilter = (props: SpecialtyFilterProps): JSX.Element => {
  const [viewAllOpen, setViewAllOpen] = useState(false);
  const [specialties, setSpecialties] = useState<Array<Specialty>>([]);
  const [openID, setOpenID] = useState('');

  const toggleViewAll = () => {
    if (viewAllOpen) {
      setViewAllOpen(false);
    } else {
      setViewAllOpen(true);
    }
  };

  const {
    addFilter,
    filters,
    filterCategory,
    placeholder,
    removeFilter,
    selectedData,
    title,
    inputType = 'checkbox',
    superSpecialties,
  } = props;

  const sortedSuperSpecialties = superSpecialties.sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  const categorizeFilters = (superSpecialty: SuperSpecialty) => {
    const categorizedFilters = Array<FacetValue>();
    specialties?.map(spec => {
      const matchingSpec = spec?.superspecialtyitem?.value.filter(
        x =>
          x.id.replaceAll('-', '').toLowerCase() ===
          superSpecialty.id.replaceAll('-', '').toLowerCase()
      )[0];
      if (matchingSpec) {
        filters?.filter(filter => filter?.text === spec?.name)[0] &&
          categorizedFilters.push(
            filters.filter(filter => filter.text === spec.name)[0]
          );
      }
    });
    return categorizedFilters;
  };

  const countSelected = (categorizedFilters: FacetValue[]) => {
    const selectedFilters = Array<FacetValue>();
    specialties.map(spec => {
      categorizedFilters.filter(
        filter => filter.text === spec.name && selectedData.includes(spec.name)
      )[0] &&
        selectedFilters.push(
          categorizedFilters.filter(
            filter =>
              filter.text === spec.name && selectedData.includes(spec.name)
          )[0]
        );
    });
    return selectedFilters?.length;
  };

  const fetchAllSpecialties = async () => {
    try {
      const searchReq = {
        widget: {
          items: [
            {
              rfk_id: getSearchWidget(),
              entity: 'specsandcfs',
              sources: [getSpecialtiesComboSearchSrc()],
              search: {
                content: {},
                limit: 100,
              },
            },
          ],
        },
      };
      const response = await Axios.post('/api/discovery', searchReq);
      setSpecialties(response.data.widgets[0].content);

      const fetches = Math.ceil(response.data.widgets[0].total_item / 100);
      const allSpecs = [...response.data.widgets[0].content];
      for (let i = 1; i < fetches; i++) {
        const nextSet = await fetchRemainingItems(i * 100);
        allSpecs.push(...nextSet);
      }
      setSpecialties(allSpecs);

      return response.data.widgets[0].content;
    } catch (error) {
      console.log('Failed to fetch facets. Error: ' + error);
    }
  };

  const fetchRemainingItems = async (offset: number) => {
    try {
      const searchReq = {
        widget: {
          items: [
            {
              rfk_id: getSearchWidget(),
              entity: 'specsandcfs',
              sources: [getSpecialtiesComboSearchSrc()],
              search: {
                content: {},
                limit: 100,
                offset: offset,
              },
            },
          ],
        },
      };
      const response = await Axios.post('/api/discovery', searchReq);
      return response.data.widgets[0].content;
    } catch (error) {
      console.log('Failed to fetch remaining facets. Error: ' + error);
    }
  };

  useEffect(() => {
    fetchAllSpecialties();
  }, []);

  return (
    <>
      {sortedSuperSpecialties.map(superSpecialty => {
        const isOpen = superSpecialty.id == openID;
        const categorizedFilters = categorizeFilters(superSpecialty);
        const count = countSelected(categorizedFilters);
        return (
          <div className="specialty-filter">
            <button
              className="superspecialty-btn"
              onClick={() => setOpenID(isOpen ? '' : superSpecialty.id)}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: superSpecialty?.Icon?.value,
                }}
              ></div>
              {superSpecialty.name}
              {count > 0 && ` (${count})`}
              <Icons
                id="pld-chevron-down"
                className={isOpen ? 'icon-up' : 'icon-down'}
              ></Icons>
            </button>
            <div className={classNames('filters-list', isOpen ? 'shown' : '')}>
              <ViewAllPanel
                addFilter={addFilter}
                filters={categorizedFilters}
                filterCategory={filterCategory}
                inputType={inputType}
                isOpen={viewAllOpen}
                placeholder={placeholder}
                removeFilter={removeFilter}
                selectedData={selectedData}
                title={title}
                toggleViewAll={toggleViewAll}
              />
            </div>
          </div>
        );
      })}
    </>
  );
};

export default SpecialtyFilter;
